import React from 'react';
interface SegmentedProps<T extends string> {
  label: string;
  value: T;
  options: {
    value: T;
    label: string;
  }[];
  onChange: (v: T) => void;
}
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange
}: SegmentedProps<T>) {
  return <fieldset data-id="element-615" data-mp="3qzid0cdnnnxb">
      <legend className="mb-2 text-sm font-semibold text-ink" data-id="element-616" data-mp="3vw8vf6cxmvlw">{label}</legend>
      <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2" data-id="element-617" data-mp="3vybpq2l4bawf">
        {options.map(o => {
        const sel = o.value === value;
        return <button key={o.value} type="button" role="radio" aria-checked={sel} onClick={() => onChange(o.value)} className={`min-h-[44px] whitespace-nowrap rounded-lg border-2 px-4 text-sm font-semibold transition-[border-color,background-color] duration-150 ease-out ${sel ? 'border-ink bg-ink text-white' : 'border-ink-200 bg-white text-ink hover:border-ink-400'}`} data-id="element-618" data-mp="3mx3u5s9zko61">
              {o.label}
            </button>;
      })}
      </div>
    </fieldset>;
}